<template>
    <div>
        <div class="grid grid-cols-12 gap-6">
            <div class="hidden md:col-span-1 md:block" />
            <div class="col-span-12 text-left md:col-span-10">
                <h2>Autoři</h2>
                <div class="mt-5 mb-5">
                    <img
                        src="../../public/img/articles/autori.webp"
                        alt=""
                        class="mb-1 aspect-auto w-full object-cover"
                    />

                    <span class="source"
                        >Archiv hl. m. Prahy je domovskou institucí většiny
                        autorů jak současného Pražského uličníku, tak
                        předchozích publikací o pražském názvosloví. / Zdroj:
                        Marek Lašťovka
                    </span>
                </div>
                <p class="mb-5 font-bold">
                    Jak knižní vydání, tak internetová aplikace, jsou dílem
                    mnoha lidí, a dá se říci i mnoha generací. Na aplikaci se
                    podílely dvě významné pražské instituce: Archiv hl. m. Prahy
                    a Institut plánování a rozvoje hl. m. Prahy.
                </p>

                <p class="font-bold">Autoři textu:</p>
                <p class="mb-5">
                    © vedoucí autorského kolektivu a hlavní autoři internetové
                    verze:
                    <span class="font-bold">Barbora a Marek Lašťovkovi</span>
                </p>

                <p class="mb-5">
                    © autoři 2. knižního vydání (2022):
                    <span class="font-bold"
                        >Barbora a Marek Lašťovkovi, Kateřina Jíšová, Josef
                        Třikač</span
                    >
                </p>

                <p class="mb-5">
                    © autor knižního historického úvodu, který byl použit za
                    základ historických textů internetové verze:
                    <span class="font-bold">Václav Ledvinka</span>
                </p>

                <p class="mb-5">
                    © autoři 1. a 2. dílu 1. knižního vydání (1997/1998):
                    <span class="font-bold"
                        >Zbyšek Bárta, Ondřej Bastl, Antonín Ederer, Jakub
                        Hrdlička, Kateřina Jíšová (tehdy Chmelařová), Marek
                        Lašťovka, Barbora Lašťovková, Sylvia Pavlicová,
                        Miroslava Přikrylová, Josef Třikač, úvod – Václav
                        Ledvinka</span
                    >
                </p>

                <p class="mb-5">
                    © autoři 3. dílu 1. knižního vydání (2012):
                    <span class="font-bold"
                        >Kateřina Jíšová, Marek Lašťovka, Barbora Lašťovková,
                        Josef Třikač</span
                    >
                </p>

                <p class="font-bold">Lektoři</p>
                <p class="mb-5">
                    RNDr. Jiří Martínek, Ph.D., Mgr. Patrik Líbal, Ph.D.
                </p>

                <p class="font-bold">Autoři webové aplikace</p>
                <p class="mb-5">
                    Mgr. Andrej Baroš, Mgr. Michal Pochmann, Ing. Zdeněk Bárta
                </p>

                <p class="font-bold">Autorka grafického řešení</p>
                <p class="mb-5">Táňa Sekerková</p>

                <p class="font-bold">Projektoví manažeři</p>
                <p class="mb-5">Mgr. Magdalena Rollová, Ing. Jan Górecki</p>

                <p class="font-bold">Instituce</p>
                <p class="mb-5">
                    <a
                        href="https://www.ahmp.cz/"
                        target="_blank"
                        class="article-link"
                        >Archiv hl. m. Prahy</a
                    >
                    <br />
                    <a
                        href="https://iprpraha.cz/o-nas"
                        target="_blank"
                        class="article-link"
                        >Institut plánování a rozvoje hl. m. Prahy</a
                    >
                    <br />
                    <a
                        href="https://praha.eu/web/praha/"
                        target="_blank"
                        class="article-link"
                        >Magistrát hl. města Prahy</a
                    >
                </p>

                <p class="font-bold">Poděkování</p>

                <p class="mb-5">
                    Náš největší dík patří současným i bývalým kolegům z Archivu
                    hlavního města Prahy –

                    <span class="font-bold">
                        Mgr. Janě Konvičné, Marii Potěšilové, PhDr. Jiřímu
                        Smržovi a Mgr. Vojtěchu Šustkovi, Ph.D.,
                    </span>

                    za cennou a nezastupitelnou pomoc při dohledávání pramenů z
                    archivních fondů. Za mnohé připomínky a upřesnění, jimiž
                    významně přispěli k vylepšení naší práce, upřímně děkujeme
                    oběma lektorům,

                    <span class="font-bold"
                        >RNDr. Jiřímu Martínkovi, Ph.D., a Mgr. Patrikovi
                        Líbalovi, Ph.D.</span
                    >

                    Za péči a četná doplnění děkujeme také jazykové redaktorce
                    knižního vydání Pražského uličníku paní
                    <span class="font-bold">Mgr. Martině Němcové.</span>
                </p>

                <p class="mb-5">
                    Za připomínky a pomoc děkujeme také mnoha dalším, a to jak
                    kolegům (nejen z Archivu hlavního města Prahy), tak
                    kronikářům, pamětníkům či zaměstnancům úřadů městských
                    částí:
                </p>

                <p class="mb-5">
                    PhDr. Danuta Beranová (Praha 12), Mgr. Dana Davidová, ÚMČ
                    Praha 14; Ing. Jiří Dvořák (Čimice); PhDr. Michal Fiala;
                    Mgr. Jitka Holíková; Hana Hořáková (Vinoř); Mgr. Jan Hrdina,
                    Ph.D.; Mgr. Tomáš Jakl (Vojenský historický ústav Praha);
                    Jaroslav Jásek (Archiv Pražských vodáren a kanalizace); Ing.
                    Kristýna Kolářová; Vlastimil Kovář; Mgr. Markéta Krejčová,
                    Mgr. Patrik Líbal, Ph.D.; Růžena Měchurová; Bc. Lucie
                    Michelová; Ing. arch. Natalie Mojžíšová (Nebušice); Dana
                    Mojžíšová (Horní Počernice); Mgr. Zdeněk Munzar (Praha 12);
                    Věra Němečková; PhDr. Martin Omelka; Eva Panzová; Ing.
                    Jaroslav Peterka (Magistrát hl. m. Prahy); Jitka Rejmonová
                    (ÚMČ Praha 1, matrika); Mgr. Jan Ryba; Jarmila Střelbová
                    (ÚMČ Praha 14); Mgr. Otakara Řebounová; Mgr. Pavla
                    Státníková (Muzeum hl. m. Prahy); PhDr. Hana Svatošová;
                    PhDr. Miroslav Veselka; Mgr. Hana Vobrátilková, Ph.D.; Mgr.
                    Petra Vokáčová, Ph.D.; Jiří Vrba; Marie Zdeňková
                    (kronikářka, ÚMČ Praha 15).
                </p>

                <p class="mb-5">
                    Uvádíme i seznam osob, jimž jsme děkovali v prvních svazcích
                    Pražského uličníku, včetně dnes již historických údajů o
                    nich, neboť zmínění mají zásluhy i na dnešním stavu poznání:
                </p>

                <p class="mb-5">
                    Hubert Antes, kronikář Horních Počernic; Dr. Jiří Bartoň,
                    kronikář Chodova; p. Bernardová ze Smíchova; Marie Bodáková,
                    Místní úřad Praha 14; Vlasta Borovičková z Řeporyjí; Alena
                    Břicháčková, pamětnice ze Zbraslavi; Jaroslav Dostálek,
                    tajemník Místního úřadu Praha – Velká Chuchle; Mgr. Milan
                    Harvalík z Onomastického ústavu AV ČR; Ing. František
                    Kadleček, starosta Zbraslavi; Mgr. Karel Kinšt, kronikář
                    Klánovic; JUDr. Olga Králová, vedoucí odboru vnitřních věcí
                    OÚ Praha 6; p. Krčmářová z Prahy 12; Ing. Kubíková ze
                    Zličína; Antonín Kučera, kronikář Řep; Ing. Kuchař z
                    Řeporyjí; Miroslav Kuranda, vedoucí Vlastivědného klubu
                    Prahy 9; Ing. Vladimír Laštovka, pamětník ze Suchdola; p.
                    Martinů, kronikář Modřan; Jaroslav Musil, kronikář Čakovic,
                    Miškovic a Třeboradic; Pavla Nápravová, kronikářka z
                    Nebušic; Ivan Němec, tajemník Místního úřadu Praha-Řeporyje;
                    PhDr. Miroslav Něnička, pamětník z Nebušic; Zdeněk Novák,
                    kronikář Dolních Chaber; Miroslav Novotný, kronikář Přední
                    Kopaniny; Stanislav Procházka, dřívější starosta Řeporyjí;
                    Dr. Daniela Rázková z Prahy 12; Jan Renčín, pamětník z
                    Běchovic; Hana Schwarzová z Místního úřadu Praha-Lipence;
                    PhDr. Tomáš Sekyrka z Archivu Národní galerie; Tomáš
                    Szennai, člen rady zastupitelstva hlavního města Prahy; Jiří
                    Slavětínský, pamětník z Jahodnice; Ondřej Vítek ze Slivence;
                    Karel Votava, kronikář Kbel; Libuše Votavová, kronikářka
                    Uhříněvsi; Ing. Miroslav Wimmer, kronikář Ďáblic; Ing.
                    Zdeněk Zeman, kronikář Kunratic.
                </p>

                <p class="mb-25">
                    Děkujeme také odboru projektové podpory Magistrátu hlavního
                    města Prahy, který na vznik aplikace Pražský uličník přispěl
                    vlastními finančními prostředky a tím významně podpořil
                    realizaci tohoto projektu.
                </p>

                <!-- next chapters -->
                <div class="mb-10 flex justify-between border-t-1 pt-5">
                    <p class="mb-5 w-1/2 border-r-1 font-bold">
                        <nuxt-link
                            to="/clanky/co-najdete-v-prazskem-ulicniku"
                            class="flex justify-start underline"
                        >
                            <img
                                src="../../public/img/left-arrow.png"
                                alt=""
                                class="order-1 mr-2 inline h-5 w-5"
                            />
                            <span class="order-2 mr-2"
                                >Co najdete v Pražském uličníku</span
                            >
                        </nuxt-link>
                    </p>
                    <p class="mb-5 w-1/2 text-right font-bold">
                        <a
                            href="https://www.academiaknihy.cz/kniha/prazsky-ulicnik-encyklopedie-nazvu-prazskych-verejnych-prostranstvi-2-prepracovane-a-doplnene-vyd/"
                            target="_blank"
                            class="article-link"
                        >
                            <span class="order-1 ml-2">Kniha</span>
                            <img
                                src="../../public/img/right-arrow.png"
                                alt=""
                                class="order-2 ml-2 inline h-5 w-5"
                        /></a>
                    </p>
                </div>
            </div>
            <div class="hidden md:col-span-1 md:block" />
        </div>

        <AppFooter />
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
